import React from 'react';
import { convertCentsToDisplayPrice } from 'utils/currency';
import Arrow from 'components/Icons/ArrowIcon';
import styles from './RevenueWidgets.module.css';
import MinusIcon from 'components/Icons/MinusIcon';

type InfoBoxProps = {
    header: string;
    data: number;
    percentage?: number;
    percentageInfo?: string;
};

function InfoBox({ header, data, percentage, percentageInfo }: InfoBoxProps): JSX.Element {
    const percentageCategory: 'zero' | 'up' | 'down' | '' =
        percentage === 0 ? 'zero' : percentage && percentage > 0 ? 'up' : percentage && percentage < 0 ? 'down' : '';

    return (
        <div className={styles.infoBoxRow}>
            <div className={styles.infoBox}>
                <p>{header}</p>
                <p className={styles.infoBoxData}>{convertCentsToDisplayPrice(data)}</p>
                {percentage !== undefined && (
                    <div className={`${styles.infoBoxUplift} ${styles[percentageCategory]}`}>
                        {percentageCategory === 'zero' ? (
                            <MinusIcon />
                        ) : (
                            <Arrow direction={percentageCategory || undefined} />
                        )}
                        <span className={styles.upliftPercentage}>{percentage}%</span>
                        <span className={styles.uplift}>{percentageInfo}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default InfoBox;
